import { Accordion, Card, Grid, InputSelect } from "#/atoms";
import { FC, memo } from "react"

import { DESKTOP_SPACING } from "@/theme";
import { ExtraServicesCardProps } from "./ExtraServices.interface"
import { HeadingIcon } from "@/components/molecules";

const ExtraServicesCard: FC<ExtraServicesCardProps> = ({
    accordionState = 'open',
    isReadOnly,
    imageMotionRequested,
    videoMotionRequested,
    virtualStagingRequested
}) => {
    return (
        <Card>
              <Accordion
                header={<HeadingIcon 
                    description="Select optional extra services"
                    icon="plus"
                    title="Extra Services" />}
                showArrow
                state={accordionState}
              >
                <Grid columnGap={DESKTOP_SPACING.XL} rowGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin={`${DESKTOP_SPACING.XXL}px 0 0`}>
                    <InputSelect
                          type="checkbox"
                          checked={videoMotionRequested.checked}
                          label={<a href="https://app.photoclear.ai" target="_blank" rel="noreferrer"> <img src="neworder_banner.png" style={{maxHeight: '85px', maxWidth: '100%'}} /></a>}
                          name="videoMotionRequested"
                          value="videoMotionRequested"
                          onChangeValue={videoMotionRequested.onChange}
                          readOnly={isReadOnly}
                          style={{marginBottom: '3px'}}
                        />

                    <InputSelect
                        type="checkbox"
                        checked={imageMotionRequested.checked}
                        label={<a href="https://www.photoplan.co.uk/service/image-motion-ai/" target="_blank" rel="noreferrer"><img src="1.jpg" style={{maxHeight: '85px', maxWidth: '100%'}} /></a>}
                        name="imageMotionRequested"
                        value="imageMotionRequested"
                        onChangeValue={imageMotionRequested.onChange}
                        readOnly={isReadOnly}
                        style={{ marginBottom: '3px'}}
                    />
                    <InputSelect
                        type="checkbox"
                        checked={virtualStagingRequested.checked}
                        label={<a href="https://virtualstaging.studio/" target="_blank" rel="noreferrer"> <img src="2.jpg" style={{maxHeight: '85px', maxWidth: '100%'}} ></img></a>}
                        name="virtualStagingRequested"
                        value="virtualStagingRequested"
                        onChangeValue={virtualStagingRequested.onChange}
                        readOnly={isReadOnly}
                        style={{marginBottom: '3px'}}
                    />
                </Grid>
              </Accordion>
        </Card>
    );
}

export default memo(ExtraServicesCard);